/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GameType = {
    _11184809: '11184809',
    INSTANT: 'INSTANT',
    DRAW: 'DRAW',
    RAPID: 'RAPID',
    FAST_PLAY: 'FAST_PLAY',
    RAFFLE: 'RAFFLE',
    unknown_default_open_api: '11184809'
} as const;
export type GameType = typeof GameType[keyof typeof GameType];


export function instanceOfGameType(value: any): boolean {
    for (const key in GameType) {
        if (Object.prototype.hasOwnProperty.call(GameType, key)) {
            if (GameType[key as keyof typeof GameType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GameTypeFromJSON(json: any): GameType {
    return GameTypeFromJSONTyped(json, false);
}

export function GameTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GameType {
    return json as GameType;
}

export function GameTypeToJSON(value?: GameType | null): any {
    return value as any;
}

